import React from 'react';
import { Badge, Row, Column } from '@upgrade/react-components';
import Fluid from '../../Fluid';
import { Heading, Text } from '../TypographyPublicSite';
import jointAccounts from '../../../../static/img/joint-accounts.svg';
import { Section } from './styles';
import { ResponsiveImage } from '../styles';

export const JOIN_ACCOUNT_PREMIER_SAVINGS_TEXT =
  'New Premier Savings accounts are available as a joint account for two account holders. To open a joint account, select this option when submitting your application.';
export const JOIN_ACCOUNT_REWARDS_CHECKING_PLUS_TEXT =
  'New Rewards Checking Plus and Performance Savings accounts are available as a joint account for two account holders. To open a joint account, select this option when starting your application.';

const JointAccounts = ({ text }) => {
  return (
    <Section borderless>
      <Fluid>
        <Row>
          <Column xs={12} sm={6}>
            <Heading as="h2" size="sm">
              Joint Accounts{' '}
              <Badge background="backgroundAccentCard" color="actionablePrimary">
                New
              </Badge>
            </Heading>
            <Text as="p" size="md">
              {text}
            </Text>
          </Column>
          <Column xs={12} sm={6} lgHorizontalAlign="end">
            <ResponsiveImage src={jointAccounts} height={206} width={342} />
          </Column>
        </Row>
      </Fluid>
    </Section>
  );
};

export default JointAccounts;
